/* KEIKA TOP: ミニサイズ訴求ポップアップ(Figma "sidebnr" 420×120) */
(function () {
  if (window.__keikaMiniPopup) return;
  window.__keikaMiniPopup = true;
  var KEY = "keika-mini-popup-closed";
  try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
  var IMG = window.__KEIKA_IMG__ || {};
  var bg = IMG["2c93637f5cfae14f.jpg"] || "shopify-theme/assets/2c93637f5cfae14f.jpg";
  var bottle = IMG["57adda7f1619ff34.png"] || "shopify-theme/assets/57adda7f1619ff34.png";
  // ミニサイズの商品ページ(本番・プレビューどちらでも開けるよう相対パス)
  var MINI_URL = "/products/twinkle-vivi%E3%83%9F%E3%83%8B%E3%82%B5%E3%82%A4%E3%82%BA";
  var photo = IMG["keika-mini-bottle.jpg"] || bottle.replace(/57adda7f1619ff34\.png.*$/, "keika-mini-bottle.jpg");
  function findLink() {
    if (window.KEIKA_MINI_URL) return window.KEIKA_MINI_URL;
    return MINI_URL;
    var list = window.KEIKA_PRODUCTS || [];
    for (var i = 0; i < list.length; i++) {
      var p = list[i], t = ((p.title || "") + " " + (p.nameEn || "") + " " + (p.url || "")).toLowerCase();
      if (t.indexOf("mini") !== -1 || t.indexOf("ミニ") !== -1) return p.url;
    }
    return "/collections/all";
  }
  var ZEN = '"Zen Kaku Gothic New", sans-serif';
  var W = "rgb(249,249,249)";
  function el(tag, css, text) {
    var e = document.createElement(tag);
    e.style.cssText = css;
    if (text != null) e.textContent = text;
    return e;
  }
  function build() {
    if (document.getElementById("keika-mini-popup")) return;
    var wrap = el("div", "position:fixed;z-index:900;left:24px;bottom:24px;width:420px;max-width:calc(100vw - 32px);opacity:0;transform:translateY(12px);transition:opacity .5s ease,transform .5s ease;");
    wrap.id = "keika-mini-popup";
    var a = el("a", "display:flex;width:100%;height:120px;text-decoration:none;color:" + W + ";background:linear-gradient(71.189deg, rgb(100,115,140) -37.74%, rgb(129,136,148) 72.09%);box-shadow:0 6px 24px rgba(20,30,50,.25);overflow:hidden;");
    a.href = findLink();
    var pic = el("div", "position:relative;flex:0 0 120px;height:120px;background:url(" + photo + ") center / cover no-repeat rgb(40,70,100);");
    a.appendChild(pic);
    var body = el("div", "position:relative;flex:1 1 auto;min-width:0;padding:16px 44px 12px 20px;display:flex;flex-direction:column;justify-content:center;gap:2px;font-family:" + ZEN + ";letter-spacing:.08em;");
    var h = el("div", "font-size:18px;line-height:28px;font-weight:500;white-space:nowrap;", "定期購入継続率");
    h.appendChild(el("span", "font-size:10px;vertical-align:super;margin-left:2px;", "※"));
    h.appendChild(document.createTextNode(" 92.22％"));
    body.appendChild(h);
    body.appendChild(el("div", "font-size:14px;line-height:24px;white-space:nowrap;", "まずはミニサイズから"));
    body.appendChild(el("div", "font-size:10px;line-height:16px;margin-top:6px;", "※半年以上継続、2026年4月時点 自社調"));
    var arrow = el("div", "position:absolute;right:20px;top:50%;width:19px;height:16px;margin-top:-8px;");
    arrow.innerHTML = '<svg width="19" height="16" viewBox="0 0 19 16" fill="' + W + '"><path d="M 11.28 16 L 19 8 L 11.28 0 L 11.005 0.283 L 16.842 7.63 L 0 6.903 L 0.017 9.097 L 16.842 8.375 L 10.988 15.7 L 11.28 16 Z"/></svg>';
    body.appendChild(arrow);
    a.appendChild(body);
    wrap.appendChild(a);
    var x = el("button", "position:absolute;top:-10px;right:-10px;width:28px;height:28px;border-radius:50%;border:none;background:" + W + ";color:rgb(35,51,85);font-size:16px;line-height:28px;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.2);padding:0;", "×");
    x.setAttribute("aria-label", "閉じる");
    x.addEventListener("click", function (e) {
      e.preventDefault();
      wrap.style.opacity = "0";
      setTimeout(function () { wrap.remove(); }, 400);
      try { sessionStorage.setItem(KEY, "1"); } catch (err) {}
    });
    wrap.appendChild(x);
    // SP: 下端いっぱいに近い幅で表示
    function resp() {
      var sp = window.innerWidth <= 820;
      wrap.style.left = sp ? "16px" : "24px";
      wrap.style.bottom = sp ? "16px" : "24px";
      wrap.style.width = sp ? "calc(100vw - 32px)" : "420px";
      h.style.fontSize = sp ? "16px" : "18px";
    }
    resp();
    window.addEventListener("resize", resp);
    document.body.appendChild(wrap);
    setTimeout(function () { wrap.style.opacity = "1"; wrap.style.transform = "none"; }, 1200);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", build);
  else build();
})();
